/**
 * Shared helpers for the Calendar resource-timeline components
 * (CalendarComponent and CalendarContainer).
 */

/**
 * Resolve the display label for a FullCalendar resource in the Container view.
 *
 * FullCalendar v6 no longer falls back to the resource's default title when a
 * content callback returns `undefined` (v5 did), so this returns the label text
 * explicitly to keep the site names visible in the resource column.
 *
 * @param {object} arg - The FullCalendar `resourceLabelContent` callback argument.
 * @returns {string} The resource label — `fieldValue`, then `resource.title`, then "".
 */
export const getContainerResourceLabel = (arg) =>
  arg?.fieldValue ?? arg?.resource?.title ?? "";
